var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 7H8.00004M4.00004 9.66667H8.00004M9.33337 13H2.66671C1.93033 13 1.33337 12.403 1.33337 11.6667V2.33333C1.33337 1.59695 1.93033 1 2.66671 1H6.39057C6.56738 1 6.73695 1.07024 6.86197 1.19526L10.4714 4.80474C10.5965 4.92976 10.6667 5.09933 10.6667 5.27614V11.6667C10.6667 12.403 10.0698 13 9.33337 13Z",
    stroke: "#6B7496",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/ListIcon.8809eeedf4325617944fc890c200b35e.svg";
export { ForwardRef as ReactComponent };